var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBagIcon = function SvgBagIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bagIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A3847",
    fillRule: "evenodd",
    d: "M14.461 5.537h2.232v-.01l.93 11.08a1.88 1.88 0 0 1-.493 1.432 1.97 1.97 0 0 1-1.455.634H4.825a2 2 0 0 1-1.454-.623 1.86 1.86 0 0 1-.503-1.422L3.677 5.57H6.04V2.64L7.34 1.337h5.819L14.46 2.64zm-1.684-2.515H7.724V5.57l5.053-.022zm-1.903 12.392-.153-1.64h3.292l.153 1.64z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bagIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.5 1.25H19v17.5H1.5z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBagIcon);
export default ForwardRef;